const instituteManagementRoutes = (prop) => [
    {
        path: 'institute-info',
        name: prop + '.institute_info',
        meta: { auth: true },
        component: () => import('../pages/institute-info/List.vue')
    },
    {
        path: 'event-management',
        name: prop + '.event_management',
        meta: { auth: true },
        component: () => import('../pages/event-management/List.vue')
    },
    {
        path: 'employee-management',
        name: prop + '.employee_management',
        meta: { auth: true },
        component: () => import('../pages/employee-management/List.vue')
    },
    {
        path: 'committee-management',
        name: prop + '.committee_management',
        meta: { auth: true },
        component: () => import('../pages/committee-management/List.vue')
    },
    {
        path: 'transportation-management',
        name: prop + '.transportation_management',
        meta: { auth: true },
        component: () => import('../pages/transportation-management/List.vue')
    },
    {
        path: 'request-form',
        name: prop + '.request_form',
        meta: { auth: true },
        component: () => import('../pages/request-form/List.vue')
    },
    {
        path: 'vendor-manage',
        name: prop + '.vendor_manage',
        meta: { auth: true },
        component: () => import('../pages/vendor/List.vue')
    },
    {
        path: 'budget-allocation',
        name: prop + '.budget_allocation',
        meta: { auth: true },
        component: () => import('../pages/budget-allocation/List.vue')
    },
    {
        path: 'resource-management',
        name: prop + '.resource_management',
        meta: { auth: true },
        component: () => import('../pages/resource-management/List.vue')
    },
    {
        path: 'library-book-information',
        name: prop + '.library_book_information',
        meta: { auth: true },
        component: () => import('../pages/book-information/List.vue')
    },
    {
        path: 'library-book-distribution',
        name: prop + '.library_book_distribution',
        meta: { auth: true },
        component: () => import('../pages/library-book-distribution/List.vue')
    },
    {
        path: 'course-management',
        name: prop + '.course_management',
        meta: { auth: true },
        component: () => import('../pages/course-management/List.vue')
    },
    {
        path: 'library-book-receive',
        name: prop + '.library_book_receive',
        meta: { auth: true },
        component: () => import('../pages/library-book-receive/List.vue')
    },
    {
        path: 'teacher-staff-assign',
        name: prop + '.teacher_staff_assign',
        meta: { auth: true },
        component: () => import('../pages/teacher-staff-assign/List.vue')
    },
    {
        path: 'teacher-staff-attendance',
        name: prop + '.teacher_staff_attendance',
        meta: { auth: true },
        component: () => import('../pages/teacher-staff-attendance/List.vue')
    }
]
const routes = [{
    path: '/disability-school-service/institute-management',
    name: 'disability_school_service.institute_management',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: instituteManagementRoutes('disability_school_service.institute_management')
}]
export default routes
